import { Text, View } from '@react-pdf/renderer';
import { Table, VGVTable } from './table';
import nls from '../../../nls/pt-BR.json';
import { FormattedPDFData } from '../usePDFData';
import { buildingLayoutDataStyles as styles } from './styles';
import { GOOD_PHASING } from '../../../redux/studies.constants';

const dictionary = nls.pdfReport.table;

interface BuildingLayoutDataProps {
  data: FormattedPDFData;
}

export const BuildingLayoutData: React.FC<BuildingLayoutDataProps> = ({
  data,
}) => {
  const {
    primaryMarketData,
    secondaryMarketData,
    absorptionAndLiquidityData,
    phasingEstimate,
  } = data;
  const isGoodPhasing = phasingEstimate && phasingEstimate <= GOOD_PHASING;
  return (
    <View>
      {secondaryMarketData && (
        <View style={styles.row}>
          <View style={styles.rowItem}>
            <Text style={{ fontSize: 14, fontFamily: 'Open Sans Bold' }}>
              {dictionary.titles.accordingToPrimaryMarket}
            </Text>

            <VGVTable
              data={primaryMarketData?.valuationVGV}
              title={dictionary.sectionTitles.VGVValuation}
            />
            <Table
              data={primaryMarketData?.installmentsSimulation}
              title={dictionary.sectionTitles.installmentsSimulation}
            />
          </View>
          <View
            style={[
              styles.rowItem,
              {
                height: secondaryMarketData?.installmentsSimulation
                  ? '100%'
                  : '50%',
              },
            ]}
          >
            <Text style={{ fontSize: 14, fontFamily: 'Open Sans Bold' }}>
              {dictionary.titles.accordingToSecondaryMarket}
            </Text>

            <VGVTable
              data={secondaryMarketData?.valuationVGV}
              title={dictionary.sectionTitles.VGVValuation}
            />
            {secondaryMarketData?.installmentsSimulation && (
              <Table
                data={secondaryMarketData?.installmentsSimulation}
                title={dictionary.sectionTitles.installmentsSimulation}
              />
            )}
          </View>
        </View>
      )}
      <View style={styles.fullWidthItem}>
        {!secondaryMarketData && (
          <View style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Text style={{ fontSize: 14, fontFamily: 'Open Sans Bold' }}>
              {dictionary.titles.accordingToPrimaryMarket}
            </Text>

            <VGVTable
              data={primaryMarketData?.valuationVGV}
              title={dictionary.sectionTitles.VGVValuation}
            />
            <Table
              data={primaryMarketData?.installmentsSimulation}
              title={dictionary.sectionTitles.installmentsSimulation}
            />
          </View>
        )}
        <Table
          data={absorptionAndLiquidityData}
          title={dictionary.sectionTitles.absorptionLiquidity}
        />
        <View
          style={[
            styles.phasingEstimate,
            isGoodPhasing ? styles.good : styles.bad,
          ]}
        >
          <Text>{dictionary.tableKeys.phasingEstimate}</Text>
          <Text>{phasingEstimate}</Text>
        </View>
      </View>
    </View>
  );
};
